// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__104ew","col":"styles_col__132mS"};